import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { AdminLayout } from '../components/layout';
import { OrderDetailLoading, OrderDetailError } from '../components/ui/LoadingSpinner';
import { useOrderDetail } from '../hooks';
import {
  OrderHeader,
  OrderItems,
  StatusBadge,
  StatusActions,
  OrderTimeline,
} from '../components/orders/OrderDetailComponents';

const OrderDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const {
    order,
    loading,
    error,
    updating,
    pendingStatus,
    updateOrderStatus,
    confirmStatusUpdate,
    cancelStatusUpdate,
  } = useOrderDetail({ orderId: id });

  const handleBackClick = () => {
    navigate('/admin/orders');
  };

  if (loading) {
    return <OrderDetailLoading />;
  }

  if (error || !order) {
    return <OrderDetailError error={error} onBackClick={handleBackClick} />;
  }

  return (
    <AdminLayout title={`Sipariş #${order.id}`}>
      {/* Header Section */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={handleBackClick}
            className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800
                     hover:bg-gray-100 rounded-lg transition-all duration-200 group"
          >
            <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
            <span className="font-medium">Sipariş Yönetimine Dön</span>
          </button>

          <StatusBadge status={order.status} />
        </div>

        <OrderHeader order={order} />
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Left Column - Order Items (Main Focus) */}
        <div className="xl:col-span-3 space-y-6">
          <OrderItems order={order} />
        </div>

        {/* Right Column - Status & Actions */}
        <div className="space-y-6">
          <StatusActions
            order={order}
            updating={updating}
            pendingStatus={pendingStatus}
            onStatusUpdate={updateOrderStatus}
            onConfirmUpdate={confirmStatusUpdate}
            onCancelUpdate={cancelStatusUpdate}
          />
          <OrderTimeline order={order} />
        </div>
      </div>
    </AdminLayout>
  );
};

export default OrderDetail;
